// Libs
import styled, { css } from 'styled-components'

// Comps
import { P } from './P'
import {
  colors,
  fontWeights,
  icons,
  alphaHex,
  forScreensGreaterThanMobileWidth,
} from '../utils'
import { backgroundElement } from '../utils/styles'
// styles
const Container = styled.div`
  width: 100%;
  max-width: 100%;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;

  .background {
    width: calc(100% - 40px);
    padding-top: 100%;

    padding-left: 20px;
    padding-right: 20px;

    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;
    border-radius: 6px;
    border: 2px dashed ${colors.washedPurple};

    p {
      ${backgroundElement}
      padding: 20px;
      width: 100%;
      height: auto;
      max-height: 100%;
      text-align: center;
      color: ${alphaHex(colors.veryDarkGray, 0.5)};
      font-weight: ${fontWeights.semiBold};
    }
  }
`

// Deffs
interface Props {
  placeholder?: string
}

export const EventItemPlaceholder: React.FC<Props> = (props) => {
  // Props
  const { placeholder } = props

  // ..
  return (
    <Container>
      <div className="background">
        <P> {placeholder || 'No events found'}</P>
      </div>
    </Container>
  )
}
